import { render } from "./CosmeticDentistry.vue?vue&type=template&id=7b229f09&scoped=true"
import script from "./CosmeticDentistry.vue?vue&type=script&lang=js"
export * from "./CosmeticDentistry.vue?vue&type=script&lang=js"

import "./CosmeticDentistry.vue?vue&type=style&index=0&id=7b229f09&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b229f09"]])

export default __exports__